
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"2 min read","minutes":1.215,"time":72900,"words":243}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A bonus favour of two reputation granted when a player’s eligible young female family member is sought out at a `}<a parentName="p" {...{
        "href": "activity"
      }}>{`social activity`}</a>{` and made the object of conspicuous attention by a male prestige guest.`}</p>
    <div className="flavor-text">
      <p>{`A favourable marriage for a daughter from a family struggling with money, image, and social standing was a common obsession in Victorian Britain and in the literature of the 19th century. Few happenings excited a family’s optimism as much as the young lady of the house being paid court at a social event by an established, wealthy, and debonair single gentleman.`}</p>
    </div>
    <p>{`The card for each family’s eligible young lady references an Admirer Bonus. This bonus is only activated when the young lady’s card is played at the same `}<a parentName="p" {...{
        "href": "activity"
      }}>{`activity`}</a>{` with a male prestige guest. The male prestige guest is identified by the presence of two fleurs-de-lis in the upper left-hand corner of the card and a reputation of three or more. When a male prestige guest is seen spending time with the young lady at an `}<a parentName="p" {...{
        "href": "activity"
      }}>{`activity`}</a>{`, the player receives two additional reputation during the “enjoy favours” stage of her turn.`}</p>
    <p>{`Note that the `}<a parentName="p" {...{
        "href": "/guest/prestige/fairchilds"
      }}>{`Charles Fairchild card`}</a>{` does not reference a reputation level. The card does, however, have 2 fleurs-de-lis in the upper left-hand corner (and also shows the Fairchild family crest in place of a reputation level); therefore, Charles is a prestige guest, and he does enable the Admirer Bonus.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Admirer Bonus"
}

